/**
 * @brisa/ui · LocaleOption
 *
 * Radio-style card menor para escolha de locale (ES/PT).
 * Estrutura permite adicionar EN/CA via prop sem refactor (i18n MVP é PT+ES).
 */
import * as React from 'react';

export interface LocaleOptionProps {
  value: 'es' | 'pt' | 'en' | 'ca';
  label: string;
  selected: boolean;
  defaultInferred?: boolean;
  inferredBadgeLabel?: string;
  onSelect: (value: 'es' | 'pt' | 'en' | 'ca') => void;
}

export function LocaleOption({
  value,
  label,
  selected,
  defaultInferred = false,
  inferredBadgeLabel = 'Sugerido',
  onSelect,
}: LocaleOptionProps) {
  return (
    <button
      type="button"
      role="radio"
      aria-checked={selected}
      onClick={() => onSelect(value)}
      data-event="onboarding-step-selecting"
      data-step="2"
      data-value={value}
      className="brisa-locale-option"
      data-selected={selected ? 'true' : 'false'}
    >
      <span className="brisa-locale-option__code">{value.toUpperCase()}</span>
      <span className="brisa-locale-option__label">{label}</span>
      {defaultInferred && (
        <span className="brisa-locale-option__badge" aria-label={inferredBadgeLabel}>
          {inferredBadgeLabel}
        </span>
      )}
    </button>
  );
}
